var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { memo } from 'react';
import cc from 'classcat';
import ScreenSizes from '../../shared/screen-sizes';
import { safeImgUrl, stringToMoment } from '../../shared/functions';
import './newspaper-tile.style.scss';
/**
 * A tile component that displays a newspaper.
 *
 * @constructor
 */
var NewspaperTile = function (props) {
    var newspaper = props.newspaper, monthViewActive = props.monthViewActive, onTileClick = props.onTileClick, children = props.children, className = props.className, index = props.index, rest = __rest(props, ["newspaper", "monthViewActive", "onTileClick", "children", "className", "index"]);
    return (React.createElement("button", __assign({ type: "button", className: cc([className, 'tfm-newspaper-tile']), onClick: function () { return onTileClick(newspaper.publicationId, newspaper.name, newspaper.datePublished); } }, rest),
        monthViewActive && (React.createElement("div", { className: "tfm-newspaper-tile-day" }, stringToMoment(newspaper.datePublished).format('dddd D MMMM'))),
        React.createElement("img", { className: "tfm-newspaper-tile-image", loading: index < 2 ? "eager" : "lazy", srcSet: "\n          " + (newspaper.imgThumbUrl ? safeImgUrl(newspaper.imgThumbUrl) + " 219w," : '') + "\n          " + safeImgUrl(newspaper.imgMobUrl) + " 300w,\n          " + (newspaper.imgSmallUrl ? safeImgUrl(newspaper.imgSmallUrl) + " 380w," : '') + "\n        ", sizes: "\n          (max-width: " + ScreenSizes.Mobile + "px) 219px, \n          (max-width: " + ScreenSizes.Monitor + "px) 300px, \n          380px\n        ", src: safeImgUrl(newspaper.imgMobUrl), alt: "\u0395\u03BE\u03CE\u03C6\u03C5\u03BB\u03BB\u03BF \u03B5\u03C6\u03B7\u03BC\u03B5\u03C1\u03AF\u03B4\u03B1\u03C2 \u03BC\u03B5 \u03B4\u03C5\u03BD\u03B1\u03C4\u03CC\u03C4\u03B7\u03C4\u03B1 \u03BA\u03BB\u03B9\u03BA " + newspaper.title }),
        !monthViewActive && (React.createElement("div", { className: "tfm-newspaper-tile-title" }, newspaper.title))));
};
NewspaperTile.defaultProps = {
    monthViewActive: true,
};
export default memo(NewspaperTile);
